import { IAttribute } from '../../base/annotation';
import { CopySink } from './copysink';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { StoreWriteSettings } from './store-write-settings/store-write-settings';
import { FormatWriteSettings } from './format-write-settings/format-write-settings';

@Metamodel.model({
    abstract: true
})
export class FormatTypeCopySink extends CopySink {
    public static readonly MODEL: IModel;
    public static readonly COPY_BEHAVIOR: IAttribute;

    // for dataset v2
    @Metamodel.attribute({
        display: stringResources.ModelName_StoreReadSettings,
        type: StoreWriteSettings.MODEL
    })
    public storeSettings: StoreWriteSettings;

    // for dataset v2
    @Metamodel.attribute({
        display: stringResources.ModelName_FormatReadSettings,
        type: FormatWriteSettings.MODEL
    })
    public formatSettings: FormatWriteSettings;
}
